export const getters = {
  systemDrivers: state => state.drivers,
  Driver: state => state.systemDriver
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/drivers/getters.js